import { css } from "glamor";
import React from "react";
import { Table } from "semantic-ui-react";
import { Spinner, colors, spacing } from "../library";
import Hint from "../library/Hint";

const contentContainer = css({
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  borderRadius: spacing.s,
  padding: spacing.m,
  background: colors.white,
  "> table": {
    border: "none !important",
    boxShadow: "none !important",
  },
  "@media(max-width: 640px)": {
    padding: spacing.s,
    "> table": {
      display: "block !important",
      width: "100% !important",
    },
    "> table thead": {
      display: "none !important",
    },
    "> table tbody": {
      display: "block !important",
      width: "100% !important",
    },
    "> table tr": {
      display: "flex !important",
      flexDirection: "column",
      width: "100% !important",
      padding: `${spacing.s} 0 !important`,
      borderBottom: `1px solid ${colors.greyLight}`,
    },
    "> table tr:last-child": {
      borderBottom: "0 !important",
    },
    "> table td": {
      display: "block !important",
      width: "100% !important",
      borderTop: "0 !important",
      padding: `${spacing.xxs} 0 !important`,
      overflowWrap: "anywhere",
    },
  },
});
const emptyText = {
  padding: spacing.xxl,
  textAlign: "center",
};
const linkClass = css({
  color: colors.primary,
  display: "flex",
  justifyContent: "end",
  paddingRight: spacing.m,
  "@media(max-width: 640px)": {
    justifyContent: "flex-start",
    paddingRight: 0,
  },
});

const tableHeaderCell = css({
  backgroundColor: `${colors.greyLight} !important`,
  ":first-child": {
    borderTopLeftRadius: `${spacing.xs} !important`,
    borderBottomLeftRadius: `${spacing.xs} !important`,
  },
  ":last-child": {
    borderTopRightRadius: `${spacing.xs} !important`,
    borderBottomRightRadius: `${spacing.xs} !important`,
  },
}).toString();

const InvoicesStatus = ({ loading }) =>
  loading ? (
    <Spinner wrapped />
  ) : (
    <p style={emptyText}>Você ainda não tem notas fiscais.</p>
  );

export default function InvoicesList(props) {
  const { invoices, loading } = props;

  return (
    <div>
       <Hint>
        * Alguns links podem não funcionar. Caso isto ocorra, entre em contato
        com nosso suporte.
      </Hint>
      {invoices?.length ? (
        <div className={contentContainer}>
          <Table striped>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell className={tableHeaderCell}>
                  Produto
                </Table.HeaderCell>
                <Table.HeaderCell
                  className={tableHeaderCell}
                ></Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {invoices.map((invoice) => (
                <Table.Row key={invoice.link}>
                  <Table.Cell>{invoice.productName}</Table.Cell>
                  <Table.Cell>
                    <div>
                      <a
                        href={invoice.link}
                        target="_blank"
                        rel="noreferrer"
                        className={linkClass}
                      >
                        Download
                      </a>
                    </div>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      ) : (
        <InvoicesStatus loading={loading} />
      )}
    </div>
  );
}
